import Component from "./PuppyPoolPartyCard";
export default Component;
